import React from 'react'
import Col from 'react-bootstrap/Col';
import { Card} from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import { BiAlarm } from "react-icons/bi";
import { BiCalendar } from "react-icons/bi";
import { BiWorld } from "react-icons/bi";
import { BiMoney } from "react-icons/bi";

function Talentcategory() {
  return (
    <div className="add_job_wrapper">
    <Row>
        <Col md={6} xs={12}>
            <h4>Web Designer</h4>
            <p>Updated: April 28, 2023 3:18 pm</p>
        </Col>                            
    </Row>
    <div class="add_job_des">
        <Row>
            <Col md={3} xs={12}>
                <Card>
                    <Card.Title>Role type</Card.Title>
                    <Card.Text><BiAlarm className='me-1'/>Part-Time (20h)</Card.Text>                                 
                </Card>
            </Col> 
            <Col md={3} xs={12}>
                <Card>
                    <Card.Title>Starting date</Card.Title>
                    <Card.Text><BiCalendar className='me-1' />April 28, 2023</Card.Text>                                 
                </Card>
            </Col>
            <Col md={3} xs={12}>
                <Card>
                    <Card.Title>Hours</Card.Title>
                    <Card.Text><BiWorld className='me-1'/>(GMT-11) Pacific/Niue</Card.Text> 
                    <Card.Text><BiAlarm className='me-1'/>1 hour</Card.Text>                                  
                </Card>
            </Col> 
            <Col md={3} xs={12}>
                <Card>
                    <Card.Title>Budget</Card.Title>
                    <Card.Text><BiMoney className='me-1'/>$5,800.00 to $18,000.00</Card.Text>                                                                      
                </Card>
            </Col>                              
        </Row>
    </div>                                    
    <div class="job_add_must_skill">
        <p>Must-have skills:</p>
        <span>JavaScript • 2 - 3 years</span>
    </div>                                
</div>
  )
}

export default Talentcategory